import { Component } from '@angular/core';

@Component({
  selector: 'app-password-warning-modal',
  templateUrl: './password-warning-modal.component.html',
  styleUrls: ['./password-warning-modal.component.css']
})
export class PasswordWarningModalComponent  {

  constructor() { }

  changePassword() {
    window.location.href = "/Account/ChangeAccountPassword";
  }
}
